import {
  BookkeepersCompanyIncidenceStatsDocument,
  BookkeepersManagementIncidenceDocument,
  BookkeepersManagementUpdateIncidenceStatusDocument,
  BookkeepersManagementUpdateIncidenceStatusMutation,
  EmployeeUpdatesDataCollectionDocument,
  PayrollBundleInHouseIncidencePageDocument,
  PayrollBundleProIncidencePageDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

import { useBookkeeperView } from 'modules/bookkeepers/lib/bookkeeperViewContext'

interface QueryParameters {
  incidenceId: string
  newIncidenceStatus: string
}

export type UpdateIncidenceStatusPayload =
  BookkeepersManagementUpdateIncidenceStatusMutation['bookkeepersManagementMutations']['updateBookkeepersmanagementIncidence']

export const useUpdateIncidenceStatus = () => {
  const isBookkeeperView = useBookkeeperView()
  const [updateIncidenceStatus, { loading }] = useMutation(
    BookkeepersManagementUpdateIncidenceStatusDocument,
    {
      context: {
        isBookkeeperView,
      },
      extractorFn: (data: BookkeepersManagementUpdateIncidenceStatusMutation) => ({
        ...data.bookkeepersManagementMutations.updateBookkeepersmanagementIncidence,
      }),
      refetchQueries: [
        BookkeepersCompanyIncidenceStatsDocument,
        BookkeepersManagementIncidenceDocument,
        EmployeeUpdatesDataCollectionDocument,
        PayrollBundleInHouseIncidencePageDocument,
        PayrollBundleProIncidencePageDocument,
      ],
      awaitRefetchQueries: true,
    }
  )

  return {
    update(params: QueryParameters) {
      return updateIncidenceStatus({ variables: params })
    },
    loading,
  }
}
